import { secret } from '../constant/globalList';
import crypt from 'crypto-js';

const enCode = (string) => {
    return crypt.AES.encrypt(string, secret.SECRET_KEY).toString();
};

const deCode = (string) => {
    const bytes = crypt.AES.decrypt(string, secret.SECRET_KEY);
    return bytes.toString(crypt.enc.Utf8);
};

export default {
    enCode,
    deCode,
};
